<template>
  <el-dialog
    custom-class="modify-datetime-batch"
    :visible.sync="dialogVisible"
    width="1080px"
    @open="onBatchModifyOpen"
    @close="onBatchModifyCancel"
  >
    <div slot="title">
      <div class="modal-title">
        <h4>{{ dialogTitle }}</h4>
        <span v-if="props.rows && props.rows.length && !showResults">已选{{ props.rows.length }}个账号</span>
      </div>
    </div>

    <div class="ghost-button-styles" v-if="!showResults">
      <el-form ref="formRef" label-width="90px">
        <el-form-item label="类型">
          <el-radio-group v-model="configForm.taskType" @change="onTaskTypeChange">
            <el-radio-button ghost :label="TASK_TYPE.TIME">时间段</el-radio-button>
            <el-radio-button ghost :label="TASK_TYPE.DATE">日期</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="修改时间段" v-if="configForm.taskType === TASK_TYPE.TIME">
          <el-radio-group v-model="configForm.timeType" @change="onTimeTypeChange">
            <el-radio-button ghost :label="TIME_TYPE.TIME_RANGE">选择时间段</el-radio-button>
            <el-radio-button ghost :label="TIME_TYPE.ALL_DAY">全天投放</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="修改日期" v-if="configForm.taskType === TASK_TYPE.DATE">
          <el-radio-group v-model="configForm.dateType" @change="onDateTypeChange">
            <el-radio-button ghost :label="DATE_TYPE.SPECIFY_DATE">具体日期</el-radio-button>
            <el-radio-button ghost :label="DATE_TYPE.LONG_TERM">长期投放</el-radio-button>
          </el-radio-group>

          <div style="margin-top: 10px" v-if="configForm.dateType === DATE_TYPE.SPECIFY_DATE">
            <el-date-picker
              v-model="configForm.startDate"
              :picker-options="{ disabledDate }"
              :clearable="true"
              style="width: 190px"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              closea
              @change="onDateChange($event, DATE_POS.START)"
            >
            </el-date-picker>
            <span>&nbsp;~&nbsp;</span>
            <el-date-picker
              v-model="configForm.endDate"
              :picker-options="{ disabledDate }"
              :clearable="true"
              style="width: 190px"
              type="date"
              placeholder="选择结束日期"
              value-format="yyyy-MM-dd"
              @change="onDateChange($event, DATE_POS.END)"
            >
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item v-if="configForm.timeType === TIME_TYPE.TIME_RANGE && configForm.taskType === TASK_TYPE.TIME">
          <div>
            <DragWeektime
              v-model="configForm.timeSchedule"
              :show-selected="false"
              :data="weektimeData"
              @change="onWeektimeChange"
            ></DragWeektime>
            <p class="week-time-tips">头条、腾讯支持半小时范围内选择，快手、百度只支持小时范围内选择。</p>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div v-loading="tableLoading" style="min-height: 260px">
      <el-table
        v-if="tableInitSuccess || showResults"
        ref="tableRef"
        class="common-el-table-styles"
        border
        :row-class-name="tableRowClassName"
        :data="tableData"
        width="100%"
      >
        <el-table-column prop="index" label="序号" width="40">
          <template slot-scope="{ $index }">
            <div>{{ $index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column label="计划名称" width="120" show-overflow-tooltip prop="adNameForBudget"></el-table-column>
        <el-table-column label="媒体" width="90" show-overflow-tooltip prop="mediaName"></el-table-column>
        <el-table-column label="项目名称" width="120" show-overflow-tooltip prop="projectNameForBudget"> </el-table-column>

        <el-table-column label="当前时间段" show-overflow-tooltip v-if="configForm.taskType === TASK_TYPE.TIME">
          <template slot-scope="{ row }">
            <ReadableWeekdays v-if="isArray(row.formatedSchedulesText)" :list="row.formatedSchedulesText"></ReadableWeekdays>
            <p v-else>{{ row.formatedSchedulesText }}</p>
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip v-if="configForm.taskType === TASK_TYPE.TIME">
          <template slot="header" slot-scope="{ row }">
            <span>修改后时间段</span>
            <el-button
              v-if="!showResults && configForm.timeType === TIME_TYPE.TIME_RANGE"
              style="margin-left: 10px"
              type="text"
              @click="onColRemoveAll(row)"
            >
              全部清除
            </el-button>
          </template>
          <template slot-scope="{ row, $index }">
            <template v-if="isArray(row.updateFormatedSchedulesText)">
              <ReadableWeekdays :list="row.updateFormatedSchedulesText"></ReadableWeekdays>
              <el-button v-if="showRowModifyBtn(row)" @click="onTableRowScheduleModify(row, $index)" type="text">&ensp;修改</el-button>
            </template>
            <p v-else>{{ row.updateFormatedSchedulesText }}</p>
          </template>
        </el-table-column>

        <div v-if="configForm.taskType === TASK_TYPE.DATE">
          <el-table-column label="投放开始时间" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <p>{{ row.currLaunchDate[0] }}</p>
            </template>
          </el-table-column>

          <el-table-column label="投放结束时间" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <p>{{ row.currLaunchDate[1] }}</p>
            </template>
          </el-table-column>

          <el-table-column label="修改后开始时间" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <span v-if="[MEDIAS.TOUTIAO].includes(row.mediaId)">———————</span>
              <div style="display: flex; justify-content: space-between; align-items: center" v-else>
                <span>{{ row.updateStartDateText || '未修改' }} </span>
                <EditActionPopover
                  @input="onTableRowDateModify(row, $event, DATE_POS.START)"
                  :value="row.updateStartDateValue"
                  :radio.sync="row.updateStartDateTypeRadio"
                  :disabledDate="disabledDate"
                  disabledLongTerm
                >
                  <el-button
                    type="text"
                    v-if="
                      (!row.hasSameProject && !showResults) ||
                      (showResults && row.dateTimeResult.projectDeepbidStatus !== 1 && row.dateTimeResult?.planId)
                    "
                    >&ensp;修改</el-button
                  >
                </EditActionPopover>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="修改后结束时间" show-overflow-tooltip>
            <template slot-scope="{ row }">
              <div style="display: flex; justify-content: space-between; align-items: center">
                <span>{{ row.updateEndDateText || '未修改' }} </span>
                <EditActionPopover
                  @input="onTableRowDateModify(row, $event, DATE_POS.END)"
                  :value="row.updateEndDateValue"
                  :radio.sync="row.updateEndDateTypeRadio"
                  :disabledDate="disabledDate"
                >
                  <el-button
                    type="text"
                    v-if="
                      (!row.hasSameProject && !showResults) ||
                      (showResults && row.dateTimeResult.projectDeepbidStatus !== 1 && row.dateTimeResult?.planId)
                    "
                    >&ensp;修改</el-button
                  >
                </EditActionPopover>
              </div>
            </template>
          </el-table-column>
        </div>

        <el-table-column label="操作" width="140" show-overflow-tooltip>
          <template slot-scope="{ $index, row }">
            <template v-if="showResults">
              <span v-if="row.dateTimeResult" class="modify-status">
                <template v-if="row.dateTimeResult.projectDeepbidStatus !== 1 && row.dateTimeResult.planId">
                  <el-button :loading="row.retryLoading" type="text" @click="onFailedRowRetry(row)">重试</el-button>
                  <span class="error"> <em class="el-icon-error"></em>修改失败</span>
                  <el-tooltip popper-class="result-error-msg-popover" effect="dark" :content="row.dateTimeResult.projectLaunchDateMsg">
                    <em v-if="row.dateTimeResult.projectLaunchDateMsg" style="margin-left: 5px" class="el-icon-warning-outline"></em>
                  </el-tooltip>
                </template>
                <template v-else>
                  <span class="success"> <em class="el-icon-circle-check"></em> 修改成功</span>
                </template>
              </span>
            </template>

            <template v-else>
              <span v-if="row.hasSameProject"> 与序号{{ row.hasSameProject }}的计划的项目相同，已做去重处理 </span>
              <el-button v-else type="text" @click="onTableRowRemove($index)">移除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="showResults" type="primary" @click="onBatchModifyCancel">我知道了</el-button>

      <template v-else>
        <div class="batch-modify-footer">
          <p class="before-submit-error-msg-tips">
            <span v-if="tableErrorMsg">{{ tableErrorMsg }}</span>
          </p>
          <div>
            <el-button @click="onBatchModifyCancel">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading" :disabled="tableData.length === 0" @click="onBatchModifyConfirm">
              确 定
            </el-button>
          </div>
        </div>
      </template>
    </span>

    <DateTimeScheduleModal v-model="showScheduleModifyModal" @confirm="onScheduleModifyConfirm"></DateTimeScheduleModal>
  </el-dialog>
</template>

<script setup>
import { ref, computed, toRef, watch } from 'vue'
import { isArray } from '@/common/js/utils.js'
import { MEDIAS } from '@/common/js/constants'
import DateTimeScheduleModal from './date-time-schedule-modal.vue'
import EditActionPopover from './edit-popover.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import weektimeData from '@/data/tencent/weektime_data'
import DragWeektime from '@/views/edit/kuaishou/components/time-range/index.vue'
import ReadableWeekdays from '@/views/edit/kuaishou/components/time-range/weekdaysTextTransformer.vue'
import { TASK_TYPE, TIME_TYPE, DATE_POS, DATE_TYPE } from './consts/index.js'
import { useConfigForm, useTableActions, useDialog, normalScheduleTransformer } from './useDateTime.js'

// eslint-disable-next-line
const props = defineProps({ value: Boolean, title: String, rows: Array })
// eslint-disable-next-line
const emit = defineEmits(['input', 'refresh', 'update:rows'])

const tableData = toRef(props, 'rows')
const visible = toRef(props, 'value')
// 投放结束日期不能小于今天
const disabledDate = (date) => date && date.valueOf() < Date.now() - 86400000

const dialogVisible = computed({
  get() {
    return visible.value
  },
  set(v) {
    emit('input', v)
  }
})

const dialogTitle = computed(() => {
  const totalLength = tableData.value.length
  const succLength = tableData.value.filter((item) => item.dateTimeResult && item.dateTimeResult.projectDeepbidStatus === 1).length

  if (showResults.value) return `共修改${totalLength}条，成功${succLength}条，失败${totalLength - succLength}条`
  return props.title
})

const {
  configForm,
  confirmLoading,
  showResults,
  onWeektimeChange,
  onTaskTypeChange,
  onTimeTypeChange,
  onDateTypeChange,
  onDateChange,
  onBatchModifyConfirm,
  onFailedRowRetry
} = useConfigForm(emit, tableData)
const {
  showScheduleModifyModal,
  tableLoading,
  tableErrorMsg,
  tableInitSuccess,
  initTableRows,
  tableRowClassName,
  showRowModifyBtn,
  onTableRowScheduleModify,
  onTableRowDateModify,
  onTableRowRemove,
  onScheduleModifyConfirm,
  onColRemoveAll
} = useTableActions(emit, tableData)

const { onBatchModifyCancel } = useDialog(dialogVisible)

/**
 * @description: 打开弹窗获取计划投放时间和日期数据，并格式化日期时间数据合并到表格列中
 * @return {*}
 */
function onBatchModifyOpen() {
  showResults.value = false
  tableInitSuccess.value = false
  initTableRows(props.rows)
}

// 父组件用 v-if 控制本弹窗，挂载时 visible 即为 true，el-dialog 的 visible watcher 非 immediate
// 不会触发 @open 事件，所以初始化与重置必须在 watch(visible, immediate) 里执行，保证每次打开都执行
watch(
  visible,
  (val) => {
    if (val) onBatchModifyOpen()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.modal-title {
  display: flex;
  align-items: center;
  h4 {
    font-size: 18px;
  }
  span {
    margin-left: 20px;
  }
}

::v-deep .el-dialog {
  margin-top: 10vh !important;
  .el-dialog__body {
    max-height: 65vh;
    overflow: auto;
  }
}

::v-deep .el-table {
  .row-disabled {
    color: #a4a4a4;
    cursor: not-allowed;
  }
}

.modify-status {
  .error {
    color: red;
  }
  .success {
    color: green;
  }
}

.week-time-tips {
  font-size: 12px;
  color: red;
}

.batch-modify-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .before-submit-error-msg-tips {
    color: red;
    font-size: 14px;
  }
}
</style>
